/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ClaimDetailPageComponent} from './claim-detail-page.component';
import {ConfirmModalComponent} from '../../shared/confirm-modal/deprecated-modals/confirm-modal.component';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ClaimInformationDisplayModule} from '../shared/claim-information-display/claim-information-display.module';
import {MaterialPositionTableModule} from '../shared/material-position-table/material-position-table.module';
import {ClaimProgressModule} from '../shared/claim-progress/claim-progress.module';
import {FileListModule} from '../../shared/file-list/file-list.module';
import {WarningsModule} from '../../shared/warnings/warnings.module';
import {ClaimInformationFormModule} from '../shared/claim-information-form/claim-information-form.module';
import {AttachmentsListDisplayModule} from '../shared/attachments-list-display/attachments-list-display.module';

@NgModule({
    declarations: [
        ClaimDetailPageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TooltipModule,
        NgbDropdownModule,
        ClaimInformationDisplayModule,
        MaterialPositionTableModule,
        ClaimProgressModule,
        FileListModule,
        WarningsModule,
        ClaimInformationFormModule,
        AttachmentsListDisplayModule
    ],
    exports: [
        ClaimDetailPageComponent
    ]
})

export class ClaimDetailPageModule {
}
